import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Actions
import * as DisputeUciActions from '../../modules/DisputeUciActions'
import { doHidePopup } from 'Store/actions/popup'

// Component
import DisputeFilterModal from './DisputeFilterModal'

// Utilities
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup()),
  ...bindActionCreators(DisputeUciActions, dispatch)
})

const TAB_KEY_MAP = { PENDING: 'pending', PROCESSING: 'inProgress', CLOSED: 'closed' }

const mapStateToProps = (state) => {
  const disputeTab = nullSafe(() => state.popup.popupInfo.disputeTab, 'PENDING')
  const tabKey = TAB_KEY_MAP[disputeTab] || 'pending'
  return {
    disputeTab,
    appliedFilters: nullSafe(() => state.DisputeUci[tabKey].filters, {}),
    regionOptions: nullSafe(() => state.DisputeUci.regions, []).map(r => ({
      label: r.name,
      value: r.code
    })),
    provinceOptions: nullSafe(() => state.DisputeUci.provinces, []).map(p => ({
      label: p.name,
      value: p.provinceCode
    })),
    regionProvinceOptions: nullSafe(() => state.DisputeUci.regionProvinces, []),
    terminals: nullSafe(() => state.DisputeUci.terminalCodes, []).map(code => ({
      id: String(code),
      label: String(code),
      value: String(code)
    }))
  }
}

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DisputeFilterModal)
